/**
 * Sports Infrastructure category config
 *
 * KPIs: category (sports category), sportType, type, quality,
 *       forRegional, forNational
 */
import type { CategoryConfig } from './CategoryConfig';

export const sportInfraConfig: CategoryConfig = {
  categoryKey: 'sportInfraProfile',
  label: 'Sports Infrastructure',
  priority: 7,

  columns: {
    defaultVisibleColumns: [
      'schoolName', 'stateName', 'roName',
      'sportType', 'type', 'quality',
      'forRegional', 'forNational',
    ],
  },
};
